import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';

import './loaderOverlay.css';

import CircularLoader, {
  CircularLoaderSize,
  CircularLoaderType,
} from '../circularLoader';

interface ICustomClassInterface {
  containerCustomClass?: string;
  loaderCustomClass?: string;
}

export interface LoaderOverlayProps {
  hasLoader?: boolean;
  hasZeroOpacity?: boolean;
  customClassName?: ICustomClassInterface;
  circularLoaderSize?: CircularLoaderSize;
  descriptionText?: string;
}

const LoaderOverlay: FC<LoaderOverlayProps> = (props: LoaderOverlayProps) => {
  const {
    hasLoader = true,
    hasZeroOpacity = false,
    customClassName,
    circularLoaderSize = CircularLoaderSize.lg,
    descriptionText,
  } = props;
  const [isClientSide, setClientSide] = useState(false);

  const className = {
    container: clsx(
      'bg-grey60 fixed flex h-full justify-center w-full z-[51]',
      hasZeroOpacity ? 'opacity-0' : 'bg-opacity-60',
      customClassName?.containerCustomClass &&
        customClassName.containerCustomClass
    ),
    loader: clsx(
      'absolute left-[calc(100vw/2-25px)] top-[calc(100vh/2-50px)]',
      customClassName?.loaderCustomClass && customClassName.loaderCustomClass
    ),
    descriptionText: 'text-white mt-20px -ml-40px',
  };

  useEffect(() => {
    setClientSide(true);
  }, []);

  return isClientSide ? (
    <div className={className.container}>
      <div className={className.loader}>
        {hasLoader && (
          <>
            <CircularLoader
              type={CircularLoaderType.primary}
              customSize={circularLoaderSize}
            />
            <p className={className.descriptionText}>{descriptionText}</p>
          </>
        )}
      </div>
    </div>
  ) : null;
};
export default LoaderOverlay;
